export function buildQueryString (queryParams = {}) {
  const entries = Object.entries(queryParams)
  if (entries.length === 0) return ''

  return '?' + entries.map(([key, value]) => `${key}=${encodeURIComponent(value)}`).join('&')
}
